import {
  DataTable,
  DataTableProps,
  DataTableStateEvent,
  DataTableValueArray,
  SortOrder,
} from 'primereact/datatable';
import React, { useCallback, useState } from 'react';

const AutoSortTable = <T extends DataTableValueArray>({
  children,
  value,
  sortField: componentSortField,
  sortOrder: componentSortOrder = 1,
  ...props
}: DataTableProps<T>) => {
  const [sortField, setSortField] = useState(() => componentSortField);
  const [order, setOrder] = useState<SortOrder>(() => componentSortOrder);

  const onSort = useCallback((e: DataTableStateEvent) => {
    setOrder(e.sortOrder);
    setSortField(e.sortField);
  }, []);

  return (
    <DataTable
      {...props}
      onSort={onSort}
      value={value}
      sortField={sortField}
      sortOrder={order}
    >
      {children}
    </DataTable>
  );
};

export default AutoSortTable;
